import HouseIcon from "@mui/icons-material/House";
import Crumb from "features/breadcrumbs/Crumb";
import { OrderParams } from "pages/order/OrderPage";
import { ChecklistParams } from "pages/checklist/ChecklistPage";
import useAssertParams from "hooks/useAssertParams";
import { useChecklistContext } from "context/ChecklistContext";

const ChecklistCrumb: React.FC = () => {
  const { orderId, checklistId } = useAssertParams<OrderParams & ChecklistParams>(
    "checklistId",
    "orderId"
  );
  const { checklist } = useChecklistContext();

  return (
    <Crumb to={`/orders/view/${orderId}/checklist/${checklistId}`} icon={<HouseIcon />}>
      {checklist.roomName}
    </Crumb>
  );
};

export default ChecklistCrumb;
